import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import DashboardCard from "../../DashboardComponents/DashboardCard"
import ListItem from "../../DashboardComponents/ListItem"
import CustomButton from "../../OnboardingComponents/CustomButton"
import { ICONS } from "../../../constants/icons"
import { useSelector } from "react-redux"

/**
 * CollaboratorsCard — role list (Future/Past) or status + role (Current).
 */
const CollaboratorsCard = ({
  collaborators = [],
  isLoading = false,
  showStatus = false,
  showViewAll = false,
  topRight,
  fullHeight = false,
}) => {
  const navigate = useNavigate()
  const { projectId } = useParams()
  const currentUserType = useSelector(state => state.auth?.currentUser?.type)

  const redirectLink = currentUserType === "member" ? `/projects/${projectId}/collaborators` : `/admin/projects/${projectId}/collaborators`

  const actions =
    topRight ||
    (showViewAll ? (
      <CustomButton
        variant="primary"
        size="sm"
        type="button"
        trailingIconSrc={ICONS.arrowRight}
        trailingIconAlt=""
        onClick={() => {
          projectId && navigate(redirectLink)
        }}
      >
        View All
      </CustomButton>
    ) : null)

  return (
    <DashboardCard
      title="Collaborators"
      tone="navy-blue"
      fullHeight={fullHeight}
      topRight={actions}
      className="dcard--no-spacing dcard--no-justify dashboard__projects-card"
    >
      <div className="project-overview__collaborators-list">
        {isLoading ? (
          Array.from({ length: 8 }, (_, index) => (
            <div
              key={`collaborator-skeleton-${index}`}
              className="project-overview__collaborator-skeleton"
              aria-hidden="true"
            >
              <span className="project-overview__collaborator-skeleton-avatar" />
              <span className="project-overview__collaborator-skeleton-name" />
              <span className="project-overview__collaborator-skeleton-role" />
            </div>
          ))
        ) : collaborators.length === 0 ? (
          <p className="project-overview__empty">No collaborators yet.</p>
        ) : (
          collaborators.map(person => (
            <ListItem
              key={person.id}
              avatarName={person.name}
              avatarSrc={person.avatar}
              title={person.name}
              subtitle={
                showStatus ? (
                  <span
                    className={`project-overview__status project-overview__status--${String(
                      person.status,
                    ).toLowerCase()}`}
                  >
                    <span className="project-overview__status-dot" />
                    {String(person.status || "")
                      .replace(/[-_]/g, " ")
                      .replace(/\b\w/g, char => char.toUpperCase())}
                  </span>
                ) : undefined
              }
              trailing={
                person.role ? (
                  <span className="project-overview__role">{person.role}</span>
                ) : null
              }
              bordered
            />
          ))
        )}
      </div>
    </DashboardCard>
  )
}

export default CollaboratorsCard
